import { render } from "./CardAside.vue?vue&type=template&id=21887ceb"
import script from "./CardAside.vue?vue&type=script&lang=js"
export * from "./CardAside.vue?vue&type=script&lang=js"
script.render = render

export default script